import { clsx } from 'clsx';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../store/auth';
import { bottomNavFor } from '../routes/nav';

/** Mobile primary navigation: five touch targets, always visible. */
export function BottomNav() {
  const user = useAuth((s) => s.user);
  const items = bottomNavFor(user?.permissions ?? []);

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 flex h-16 items-stretch border-t border-line bg-surface-1/95 backdrop-blur lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary"
    >
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => clsx(
              'flex min-w-touch flex-1 flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors',
              isActive ? 'text-brand-600 dark:text-brand-400' : 'text-ink-faint hover:text-ink',
            )}
          >
            <Icon className="h-5 w-5" aria-hidden />
            <span className="truncate">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
